var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content login"},[_c('div',{staticClass:"logo_img animated tada",on:{"click":_vm.test}},[_vm._m(0)]),_c('div',{staticClass:"rightbox"},[_vm._l((_vm.box_list[0].length),function(item_y,y){return [_vm._l((_vm.box_list.length),function(item_x,x){return [_c('div',{key:x + '_' + y,staticClass:"animated",class:{
            rotateIn: _vm.box_list[x][y].item_type == 2,
            zoomInRight: _vm.box_list[x][y].item_type != 2,
            delay_0: _vm.box_list[x][y].item_type == 2,
            delay_1: _vm.box_list[x][y].item_type != 2,
          },attrs:{"pos":x + '_' + y}},[(_vm.box_list[x][y] != 0)?_c('div',{staticClass:"empty menu_node",class:{
              nopower_box:
                !_vm.box_list[x][y].power && //权限false
                _vm.box_list[x][y] != 0 && //有节点
                _vm.box_list[x][y].item_type != 2, //非图标
              menu_node_hover: _vm.box_list[x][y].item_type != 2, //2是图标
              menu_img: _vm.box_list[x][y].item_type == 2, //图标

              quit_box: _vm.box_list[x][y].webName == _vm.quit_name,
            },style:({
              backgroundColor: _vm.box_list[x][y].bg_color
                ? _vm.box_list[x][y].bg_color
                : '',
              backgroundImage:
                _vm.box_list[x][y].bg_1 == ''
                  ? ''
                  : 'url(' + require(`${_vm.box_list[x][y].bg_1}`) + ')',
              opacity: _vm.box_list[x][y].opacity ? _vm.box_list[x][y].opacity : 1,
            }),on:{"click":function($event){return _vm.nodeClick(_vm.box_list[x][y])}}},[(_vm.box_list[x][y].show_text)?_c('p',[_vm._v(" "+_vm._s(_vm.box_list[x][y].webName)+" ")]):_vm._e()]):_c('div')])]})]})],2),_c('div',[_c('a-modal',{attrs:{"title":"提示","footer":null},model:{value:(_vm.dialogVisible),callback:function ($$v) {_vm.dialogVisible=$$v},expression:"dialogVisible"}},[_c('div',[_vm._v("您没有访问权限！")]),_c('div',{staticStyle:{"width":"100%","text-align":"right","margin":"20px 0 5px 0"}},[_c('a-button',{attrs:{"type":"primary"},on:{"click":() => {
              _vm.dialogVisible = false;
            }}},[_vm._v("确认")])],1)])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo_text",staticStyle:{"padding-left":"1%"}},[_c('p',[_vm._v("金山区分区计量管理系统")])])
}]

export { render, staticRenderFns }